import styled from '@emotion/styled';
import { useState, useRef } from 'react';
import { MOBILE_QRY } from '~/config';
import CloseButton from '~/components/CloseButton';
import Header from '~/components/Header';
import EstimateForm from './EstimateForm';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ESTIMATE_LIST_ROUTE } from '~/constants/routes';
import TemplateSelector from './TemplateSelector';
import EstimateFormPhone from './EstimateFormPhone';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import WarningModal from './WarningModal';

const Wrapper = styled.div`
  background: var(--content1);
  padding: 0;
  min-height: 100vh;

  ${MOBILE_QRY} {
    padding: 48px;
  }
`;

const AddEstimate = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editEstimateUuid = searchParams.get('editUuid') as string;
  const isDesktop = useIsDesktop();
  const [showWarningModal, setShowWarningModal] = useState(false);
  const isNavigatingAway = useRef(false);

  const handleClose = () => {
    setShowWarningModal(true);
  };

  const handleConfirmClose = () => {
    isNavigatingAway.current = true;
    navigate(ESTIMATE_LIST_ROUTE);
  };

  const handleCancelClose = () => {
    setShowWarningModal(false);
  };

  return (
    <div>
      <Header
        headerText={editEstimateUuid ? 'Edit Estimate' : 'New Estimate'}
        rightJsx={<CloseButton onClose={handleClose} />}
      />
      <Wrapper>
        <TemplateSelector />

        {isDesktop ? <EstimateForm /> : <EstimateFormPhone />}
      </Wrapper>

      <WarningModal
        isVisible={showWarningModal}
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </div>
  );
};

export default AddEstimate;
